// Original vocabulary. Role tags constrain where a noun may be used.
export default [
  {
    "id": "toy-rocket",
    "role": "countable",
    "singular": "toy rocket",
    "plural": "toy rockets",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "planet-sticker",
    "role": "countable",
    "singular": "planet sticker",
    "plural": "planet stickers",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "star-token",
    "role": "countable",
    "singular": "star token",
    "plural": "star tokens",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-satellite",
    "role": "countable",
    "singular": "toy satellite",
    "plural": "toy satellites",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "moon-model",
    "role": "countable",
    "singular": "moon model",
    "plural": "moon models",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "space-badge",
    "role": "countable",
    "singular": "space badge",
    "plural": "space badges",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-rover",
    "role": "countable",
    "singular": "toy rover",
    "plural": "toy rovers",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-astronaut",
    "role": "countable",
    "singular": "toy astronaut",
    "plural": "toy astronauts",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "space-card",
    "role": "countable",
    "singular": "space card",
    "plural": "space cards",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "meteor-model",
    "role": "countable",
    "singular": "meteor model",
    "plural": "meteor models",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "ribbon",
    "role": "measurable",
    "singular": "ribbon",
    "plural": "ribbons",
    "tags": [
      "length"
    ]
  },
  {
    "id": "rope",
    "role": "measurable",
    "singular": "rope",
    "plural": "ropes",
    "tags": [
      "length"
    ]
  },
  {
    "id": "wire",
    "role": "measurable",
    "singular": "wire",
    "plural": "wires",
    "tags": [
      "length"
    ]
  },
  {
    "id": "cable",
    "role": "measurable",
    "singular": "cable",
    "plural": "cables",
    "tags": [
      "length"
    ]
  },
  {
    "id": "box",
    "role": "container",
    "singular": "box",
    "plural": "boxes",
    "tags": []
  },
  {
    "id": "case",
    "role": "container",
    "singular": "case",
    "plural": "cases",
    "tags": []
  },
  {
    "id": "tray",
    "role": "container",
    "singular": "tray",
    "plural": "trays",
    "tags": []
  },
  {
    "id": "bag",
    "role": "container",
    "singular": "bag",
    "plural": "bags",
    "tags": []
  },
  {
    "id": "astronaut",
    "role": "person",
    "singular": "astronaut",
    "plural": "astronauts",
    "tags": []
  },
  {
    "id": "scientist",
    "role": "person",
    "singular": "scientist",
    "plural": "scientists",
    "tags": []
  },
  {
    "id": "engineer",
    "role": "person",
    "singular": "engineer",
    "plural": "engineers",
    "tags": []
  },
  {
    "id": "visitor",
    "role": "person",
    "singular": "visitor",
    "plural": "visitors",
    "tags": []
  },
  {
    "id": "mission",
    "role": "action",
    "singular": "mission",
    "plural": "missions",
    "tags": []
  },
  {
    "id": "launch",
    "role": "action",
    "singular": "launch",
    "plural": "launches",
    "tags": []
  },
  {
    "id": "training-session",
    "role": "action",
    "singular": "training session",
    "plural": "training sessions",
    "tags": []
  },
  {
    "id": "observation",
    "role": "action",
    "singular": "observation",
    "plural": "observations",
    "tags": []
  },
  {
    "id": "space-station",
    "role": "structure",
    "singular": "space station",
    "plural": "space stations",
    "tags": []
  },
  {
    "id": "launch-tower",
    "role": "structure",
    "singular": "launch tower",
    "plural": "launch towers",
    "tags": []
  },
  {
    "id": "observatory",
    "role": "place",
    "singular": "observatory",
    "plural": "observatories",
    "tags": []
  },
  {
    "id": "launch-site",
    "role": "place",
    "singular": "launch site",
    "plural": "launch sites",
    "tags": []
  }
];
